import { Api } from "@/api/Api";
import type { AlertNotification, AlertNotificationPage } from "@mm/metx-workbench.meteomatics.com";

export type { AlertNotification };
export type NotificationSnapshot = AlertNotificationPage;

const NOTIFICATIONS_LIMIT = 10;

export function markNotificationRead(id: string) {
  return Api.alert.v2MarkAlertNotificationRead({ notificationId: id });
}
export function markAllNotificationsRead() {
  return Api.alert.v2MarkAllAlertNotificationsRead();
}

export async function fetchNotificationSnapshot(signal?: AbortSignal): Promise<NotificationSnapshot> {
  const page = await Api.alert.v2GetAlertNotifications({ limit: NOTIFICATIONS_LIMIT }, { signal, cache: "no-store" });
  const items = [...page.items].sort(
    (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at) || b.id.localeCompare(a.id),
  );
  return { items };
}

export function fetchNotificationDestination(subscriptionId: string, profileId?: number, signal?: AbortSignal) {
  return Api.alert.v2GetAlertNotificationDestination(
    { subscriptionId, ...(Number.isInteger(profileId) ? { profileId } : {}) },
    { signal },
  );
}
